<template>
  <div>
    <slots-head
      :item="item"
      :type="type"
      @saveNameEdit="(value, item) => saveNameEdit(value, item)"
      @deleteItem="(item) => deleteItem(item)"
    >
      <a v-show="type != 'edit'" @click="() => ViewMOre(item.componentKey+'-all')">
        {{ $t('page_mdc_alarm_view_all') }}
      </a>
    </slots-head>
    <div :id="'makino-worktable' + id" style="width:100%;height:100%;padding: 0 8px;">
      <ml-table
        :columns="columns"
        :data-source="dataSource"
        :scroll="{ x: 0, y: scrolllY }"
      >
        <template slot="code" slot-scope="text, record">
          <div style="cursor: pointer; color: rgb(69, 124, 190);" @click="navTo(text, record)">{{text}}</div>
        </template>
      </ml-table>
    </div>
  </div>
</template>

<script>
import mixin from './cardmixin.vue'
import { WorkRecordServiceProxy } from '@/service-proxies/app-v2/work-record.service-proxies'
import dayjs from 'dayjs'
const wrsp = new WorkRecordServiceProxy()

export default {
  name: 'PendingWork',
  mixins: [mixin],
  data() {
    return {
      scrolllY: 0,
      dataSource: []
    }
  },
  mounted() {
    this.getList()
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_ops_work_record_document_number'),
          dataIndex: 'code',
          ellipsis: true,
          key: 'code',
          scopedSlots: { customRender: 'code' },
        },
        {
          title: this.$t('page_ops_work_record_customer_name'),
          dataIndex: 'customerName',
          ellipsis: true,
          key: 'customerName'
        },
        {
          title: this.$t('page_ops_work_record_submit_time'),
          dataIndex: 'submitTime',
          width: 160,
          ellipsis: true,
          key: 'submitTime',
          customRender: (time) => {
            return <div>{dayjs(time).format('YYYY-MM-DD HH:mm:ss')}</div>
          }
        },
        {
          title: this.$t('page_process'),
          dataIndex: 'processProgress',
          ellipsis: true,
          width: 80,
          key: 'processProgress',
          customRender: (text) => {
            return <a-tag color={this.checkStatus(text)}>{this.checkName(text)}</a-tag>
          }
        }
      ]
    }
  },
  methods: {
    navTo(keyWord, record) {
      if(record.processProgress === '0') {
        this.ViewMOre('record-history', {keyWord});
      } else {
        this.ViewMOre('pending-work', {keyWord});
      }
    },
    checkName(key) {
      console.log(key === 1)
      let name = ''
      switch (key) {
        case '1':
          name = '待派发'
          break
        case '2':
          name = '待处理'
          break
        case '3':
          name = '待审核'
          break
        case '0':
          name = '已完成'
          break
        default:
          break
      }
      return name
    },
    checkStatus(key) {
      let status = ''
      switch (key) {
        case '1':
          status = 'blue'
          break
        case '2':
          status = 'orange'
          break
        case '3':
          status = 'green'
          break
        case '0':
          status = 'purple'
          break
      }
      return status
    },
    async getList() {
      wrsp
        .getWorkRecordList(
          1,
          {
            contactUserName: '',
            deviceTypeIds: [],
            processProgress: [],
            questionDescription: '',
            regionIds: [],
            submitUserId: ''
          },
          8
        )
        .then((res) => {
          if (res && res.records) {
            this.dataSource = res.records
            const dev = document.getElementById('makino-worktable' + this.id)
            if (dev && this.dataSource.length * 33 > dev.clientHeight - 34) {
              this.scrolllY = dev.clientHeight - 34
            } else {
              this.scrolllY = 0
            }
          } else {
            this.dataSource = []
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.workhistory-list {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
}
.workhistory-list-box {
  width: 125px;
  height: 160px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.distributed-box {
  background-color: #e6f7ff;
  border-radius: 2px;
  border: solid 1px #91d5ff;
  &-number {
    font-size: 40px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #4a90e2;
  }
  &-name {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: rgba(0, 0, 0, 0.65);
  }
  &-more {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    margin-top: 16px;
    color: rgba(0, 0, 0, 0.25);
    cursor: pointer;
    text-decoration: underline;
  }
}
.pending-box {
  background-color: #fff7e6;
  border-radius: 2px;
  border: solid 1px #ffa940;
  &-number {
    font-size: 40px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #f5a623;
  }
  &-name {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: rgba(0, 0, 0, 0.65);
  }
  &-more {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    margin-top: 16px;
    color: rgba(0, 0, 0, 0.25);
    cursor: pointer;
    text-decoration: underline;
  }
}
.reviewed-box {
  background-color: #f6ffed;
  border-radius: 2px;
  border: solid 1px #b7eb8f;
  &-number {
    font-size: 40px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #52c41a;
  }
  &-name {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: rgba(0, 0, 0, 0.65);
  }
  &-more {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    margin-top: 16px;
    color: rgba(0, 0, 0, 0.25);
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
